(function() {
  'use strict';

  angular
      .module('showcaseApp')
      .constant('cpfCnpjFilterConstants', {
          NAME: 'cpfCnpj',
          TYPE: {
              CPF: 'cpf',
              CNPJ: 'cnpj'
          }
      });
})();
